if ('objectFit' in document.documentElement.style === false) { // browser doesn't support object fit

  let images = [...document.getElementsByTagName('IMG')]; // gets all images in the page
  
  images.forEach( image => {

    let parentContainer = image.parentElement;
    let hasContainerClass = (parentContainer.classList.contains('image-cont') || parentContainer.classList.contains('img-cont') || parentContainer.classList.contains('object-fit-cover')) ? true : false; // check for the container class that we want to target
    
    if (hasContainerClass) {
      // do the magic
      let imageSrc = image.src;
      image.style.opacity = 0;

      // set the styles
      parentContainer.style.backgroundImage = `url(${imageSrc})`;
      parentContainer.style.backgroundSize = 'cover';
      parentContainer.style.backgroundRepeat = 'no-repeat';
      parentContainer.style.backgroundPosition = '50% 50%';
    }

  })

}